import { resolveElementFromPath } from '@src/utility/compositionSettings';

import type { ElementLike } from '@src/utility/compositionSettings';

/**
 * Whether the speaker's headshot may be written into a pull-quote card: only
 * while the card has no photo of its own — its headshot element is empty or
 * still shows the template's placeholder. A photo the user picked, or one the
 * card was saved with, is never replaced (PLAT-11977).
 */
export function canFillSpeakerHeadshot(
  cardComposition: ElementLike | undefined,
  templateSource: Record<string, unknown>,
  path: number[],
  property: string,
): boolean {
  const current = cardComposition
    ? resolveElementFromPath(cardComposition, path)?.[property]
    : undefined;
  if (!current) return true;
  const placeholder = resolveElementFromPath(templateSource, path)?.[property];
  return current === placeholder;
}
